import { initCarousels } from "../carousel/";

// ============================================================================
// Blog page carousels
// ============================================================================

// ---- FEATURED SLIDER -------------------------------------------------------
// The autoplaying hero carousel at the top, with external prev/next buttons.
document.addEventListener("DOMContentLoaded", function () {
  const instances = initCarousels(".blog-featured__slider-list", {
    cellAlign: "left",
    contain: true,
    pageDots: false,
    wrapAround: true,
    autoPlay: 3000,
  });

  if (instances && instances.length > 0) {
    const slider = instances[0].flickity;

    const prev = document.querySelector(
      ".blog-featured__slider-nav-button.prev",
    );
    const next = document.querySelector(
      ".blog-featured__slider-nav-button.next",
    );

    if (prev) {
      prev.addEventListener("click", function () {
        slider.previous();
      });
    }
    if (next) {
      next.addEventListener("click", function () {
        slider.next();
      });
    }
  }
});

// ---- CATEGORIES CAROUSEL ---------------------------------------------------
// Horizontal scroller for the category filter pills. No nav buttons, no
// wrap-around, no autoplay — just a draggable strip.
document.addEventListener("DOMContentLoaded", function () {
  initCarousels(".blog-post__categories-list", {
    cellAlign: "left",
    contain: true,
    pageDots: false,
    wrapAround: false,
    draggable: true,
  });
});
